export enum stripeAccountStatus {
  not_created = "not_created",
  pending = "pending",
  completed = "completed",
}
